<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานหลัก</label>
                                <Button
                                    @click="showOrganize = true"
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_6_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteTable = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="event_name">{{ $t('event_name') }}</label>
                            <InputText
                                id="event_name"
                                type="text"
                                v-model="event_name"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_3_search', 'Input')"
                            />
                        </div>

                        <div class="p-col p-grid p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="startDate">{{ $t('startDate') }}</label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    :showButtonBar="true"
                                    :maxDate="setTimeMaxMin(toDate)"
                                    :monthNavigator="true"
                                    :yearNavigator="true"
                                    yearRange="2000:2050"
                                    :locale="th"
                                    id="disaster_startDate"
                                    v-model="startDate"
                                ></Calendar>
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="toDate">{{ $t('toDate') }}</label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    :showButtonBar="true"
                                    :minDate="setTimeMaxMin(startDate)"
                                    :monthNavigator="true"
                                    :yearNavigator="true"
                                    yearRange="2000:2050"
                                    :locale="th"
                                    id="disaster_toDate"
                                    v-model="toDate"
                                ></Calendar>
                            </div>
                        </div>

                        <div class="p-col p-grid p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disasterType">{{ $t('disaster_type') }}</label>
                                <Dropdown
                                    v-model="disasterTypeSelect"
                                    :options="disasterTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterTypeOptions">
                                        <div v-if="disasterTypeOptions.value">
                                            <div>{{ disasterTypeOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterTypeOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterTypeOptions">
                                        <div>{{ disasterTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disasterStatusOptions">{{ $t('disaster_status') }}</label>
                                <Dropdown
                                    v-model="disasterStatusSelect"
                                    :options="disasterStatusOptions"
                                    optionLabel="name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterStatusOptions">
                                        <div v-if="disasterStatusOptions.value">
                                            <div>{{ disasterStatusOptions.value.name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterStatusOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterStatusOptions">
                                        <div>{{ disasterStatusOptions.option.name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-col p-grid p-mt-1">
                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="selectedProvince"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="selectedAmphur"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="selectedTambon"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-col p-grid p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disaster_location">{{ $t('disaster_location') }}</label>
                                <InputText
                                    id="disaster_location"
                                    type="text"
                                    v-model="disaster_location"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Input')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="disasterDetailOptions">{{ $t('disaster_detail') }}</label>
                                <InputText
                                    id="disaster_detail"
                                    type="text"
                                    v-model="disaster_detail"
                                    ref="TextBox_4_search"
                                    @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_6_search', 'Button')"
                                />

                                <!-- <Dropdown
                  v-model="disasterDetailSelect"
                  :options="disasterDetailOptions"
                  optionLabel="system_name"
                  :filter="true"
                  :placeholder="$t('placeholderSelectBox')"
                  :showClear="true"
                >
                  <template #value="disasterDetailOptions">
                    <div v-if="disasterDetailOptions.value">
                      <div>{{ disasterDetailOptions.value.system_name }}</div>
                    </div>
                    <span v-else>
                      {{ disasterDetailOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="disasterDetailOptions">
                    <div>{{ disasterDetailOptions.option.system_name }}</div>
                  </template>
                </Dropdown> -->
                            </div>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                <Button
                                    @click="clearSearchField()"
                                    :label="$t('clearBtn')"
                                    class="p-button-clear p-ml-3 p-mr-3 p-mt-2"
                                    ref="TextBox_5_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_6_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_3_search', 'Input')"
                                />
                                <Button
                                    @click="searchDisasterInfo()"
                                    :label="$t('searchBtn')"
                                    class="p-button-info p-mt-2"
                                    ref="TextBox_6_search"
                                    @keyup.left="moveFocus($event, 'TextBox_5_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="disasterInfo_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <!-- <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
      ></organize-table>
    </Dialog> -->

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table @selectOrganization="selectedOrganize_passValue" :parentmessage="parentmessage_organize"></organize-table>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <DataTable
                :value="disasterInfo_table"
                :paginator="true"
                :rows="10"
                :loading="loading"
                dataKey="id"
                :rowHover="true"
                :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                :rowClass="rowClass"
            >
                <template #header>
                    <div style="display: flex; justify-content: flex-end">
                        <div class="p-col-12 p-lg-3">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" /><InputText v-model="filters['global']" :placeholder="$t('searchHeader')" />
                            </span>
                        </div>
                    </div>
                </template>
                <template #empty>{{ $t('TableEmpty') }}</template>
                <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div class="table_row">
                            {{ dataTable.data.index }}
                        </div>
                    </template>
                </Column>

                <Column field="event_name" :header="$t('event_name')" :sortable="true" :headerStyle="tableColSticky('250px', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div hidden>{{ dataTable.data.hazard_id }}</div>
                        {{ dataTable.data.event_name }}
                    </template>
                </Column>

                <Column
                    field="event_date_alias"
                    :header="$t('disaster_callDatetime')"
                    :sortable="true"
                    :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.event_date_alias }}
                    </template>
                </Column>
                <Column
                    field="disaster_name"
                    :header="$t('disaster_type')"
                    :sortable="true"
                    :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.disaster_name }}
                    </template>
                </Column>

                <Column
                    field="disaster_detail"
                    :header="$t('disaster_detail')"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div
                            v-if="
                                dataTable.data.disaster_detail != 'null' &&
                                dataTable.data.disaster_detail !== '' &&
                                dataTable.data.disaster_detail !== null
                            "
                        >
                            {{ dataTable.data.disaster_detail }}
                        </div>
                        <div v-else>-</div>
                    </template>
                </Column>

                <Column
                    field="report_phone"
                    :header="'เบอร์โทรศัพท์ผู้แจ้งเหตุ'"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div
                            v-if="dataTable.data.report_phone != 'null' && dataTable.data.report_phone !== '' && dataTable.data.report_phone !== null"
                        >
                            {{ dataTable.data.report_phone }}
                        </div>
                        <div v-else>-</div>
                    </template>
                </Column>

                <Column
                    field="event_operator_table"
                    :header="$t('main_organize')"
                    :sortable="true"
                    :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div v-if="dataTable.data.event_operator_table == '[]'">-</div>
                        <div v-else>
                            <div v-for="operator in JSON.parse(dataTable.data.event_operator_table)" :key="operator.operating_id">
                                <div v-if="operator.organize[0] == '1'">
                                    {{ operator.operating_name }}
                                </div>
                                <div v-else>-</div>
                            </div>
                        </div>
                    </template>
                </Column>

                <Column
                    field="event_level"
                    :header="$t('disaster_level')"
                    :sortable="true"
                    :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <!-- {{ dataTable.data.event_level }} -->

                        <div v-if="dataTable.data.event_level == '1'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#00BFFF',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '2'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#006400',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '3'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#FFFF00',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '4'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#FF8C00',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.event_level == '5'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#FE0000',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                        <div v-else class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#A09B9B',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    color: '#002678',
                                    fontWeight: 'bolder',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ dataTable.data.event_level }}
                            </div>
                        </div>
                    </template>
                </Column>
                <Column
                    field="event_status"
                    :header="$t('disaster_status')"
                    :sortable="true"
                    :headerStyle="tableColSticky('12rem', 'center', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div v-if="dataTable.data.event_status == 'onworking'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#F1C40F',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ $t('onworking') }}
                            </div>
                        </div>

                        <div v-else-if="dataTable.data.event_status == 'finish'" class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#2ECC71',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ $t('finish') }}
                            </div>
                        </div>

                        <div v-else class="table_row">
                            <div
                                :style="{
                                    color: '#fff',
                                    backgroundColor: '#E74C3C',
                                    display: 'inline-flex',
                                    padding: '5px',
                                    paddingLeft: '15px',
                                    paddingRight: '15px',
                                    borderRadius: '10px'
                                }"
                            >
                                {{ $t('notify') }}
                            </div>
                        </div>
                    </template>
                </Column>
                <!-- <Column
          field="location"
          :header="$t('disaster_location')"
          :sortable="true"
          headerStyle="width: 250px"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.location != ''">
              {{ dataTable.data.location }}
            </div>
            {{ dataTable.data.tambon_name }} {{ dataTable.data.amphur_name }}
            {{ dataTable.data.province_name }}
          </template>
        </Column> -->

                <Column
                    field="date_create_ddmmyy"
                    :header="'วันที่สร้างข้อมูล'"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.date_create_ddmmyy }}
                    </template>
                </Column>

                <Column
                    field="date_update_ddmmyy"
                    :header="'วันที่ปรับปรุงข้อมูล'"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        {{ dataTable.data.date_update_ddmmyy }}
                    </template>
                </Column>

                <Column header="ยืนยันเหตุการณ์" :headerStyle="table_headerStyle" :bodyStyle="table_bodyStyle">
                    <template #body="dataTable">
                        <div v-if="dataTable.data.from_flag == 0">
                            <div class="p-formgrid col_manege">
                                <div :class="table_BOXmanege">
                                    <Button
                                        @click="updateStatus(1, dataTable.data.hazard_id)"
                                        icon="pi pi-check"
                                        class="p-button-rounded p-button-success"
                                    />
                                </div>
                                <div :class="table_BOXmanege">
                                    <Button
                                        @click="updateStatus(-1, dataTable.data.hazard_id)"
                                        icon="pi pi-times"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.from_flag == -1" class="p-text-italic reject-label">ปฏิเสธข้อมูล</div>
                        <div v-else class="p-formgrid col_manege" :style="checkInnerWidth_ChangeBackGround('finish')">
                            <div class="p-text-italic approve-label" style="height: 100%">บันทึกข้อมูล</div>
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>

        <!-- Operator confirm or reject the disaster -->
        <Dialog :modal="true" :header="$t('ConfirmApproveModal')" :visible.sync="displayApproveModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span v-if="temp.status == 1">เหตุสาธารณภัยนี้ว่าเป็นข้อเท็จจริงใช่หรือไม่</span>
                <span v-else>เหตุสาธารณภัยนี้ไม่เป็นความจริงใช่หรือไม่</span>
            </div>
            <template #footer>
                <Button
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    @click="
                        displayApproveModal = false;
                        temp = {};
                    "
                    class="p-button-text"
                />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="updateDisaster()" class="p-button-text" autofocus />
            </template>
        </Dialog>
    </div>
</template>

<script>
// import organizeTable from "./OrganizeTable";
import organizeTable from '../Report/OrganizeMultiSelectTable.vue';
import moment from 'moment';

import textFooter from '../../mixins/textFooter_Search_html';

export default {
    components: {
        organizeTable,
        textFooter
    },
    data() {
        return {
            dropdownClearFilerValue: 0,
            checkRole: null,
            event_name: '',
            disaster_detail: '',
            startDate: null,
            toDate: null,
            disasterTypeOptions: [],
            disasterTypeSelect: null,
            disasterDetailOptions: [],
            disasterDetailSelect: null,
            disasterStatusOptions: [
                { id: 'onworking', name: this.$i18n.t('onworking') },
                { id: 'finish', name: this.$i18n.t('finish') },
                { id: 'notify', name: this.$i18n.t('notify') }
            ],
            disasterStatusSelect: null,
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,
            disaster_location: '',
            showOrganize: false,
            selectedOrganize: {},
            disasterInfo_table: [],
            filters: {},
            selectedData: '',
            loading: false,
            displayApproveModal: false,
            temp: {},
            disasterpeople_disable: true,

            deleteTable: '',
            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('10rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('10rem', 'Body'),

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานหลัก',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อเหตุการณ์',
                    textShow: ''
                },
                {
                    DataName: 'จากวันที่',
                    textShow: ''
                },
                {
                    DataName: 'ถึงวันที่',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสาธารณภัย',
                    textShow: ''
                },
                {
                    DataName: 'สถานะเหตุการณ์',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'สถานที่เกิดเหตุ',
                    textShow: ''
                },
                {
                    DataName: 'ลักษณะที่เกิดเหตุ',
                    textShow: ''
                }
            ]

            // BackGroundCol:this.checkInnerWidth_ChangeBackGround()
        };
    },
    watch: {
        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-amphur', province_id: val.province_id }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-tambon', amphur_id: val.amphur_id }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async disasterTypeSelect(val) {
            if (val != null) {
                this.disasterDetailSelect = null;
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-detail-disaster', id: val.system_id }
                    })
                    .then((response) => {
                        (this.disasterDetailOptions = response.data.data),
                            this.disasterDetailOptions.splice(0, 0, {
                                system_id: 'getall',
                                system_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.disasterDetailOptions = [];
                this.disasterDetailSelect = null;
            }
        },

        startDate(val) {
            if (val == null) {
                this.toDate = null;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
    },
    created() {
        console.log('d');
        this.initialData();
        this.checkRole = this.decodeJWT(localStorage.getItem('token')).permission_id;

        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_5_search') && !this.isFocused('TextBox_6_search')) {
                    this.searchDisasterInfo();
                }
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('10rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('10rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        checkInnerWidth_ChangeBackGround(status) {
            if (status == 'finish') {
                return {
                    // backgroundColor:'#cdffc9'
                };
            }
            //  else{
            //   return {
            //     backgroundColor:'#E74C3C'
            //   }
            //  }
        },
        async initialData() {
            let temporary = this.decodeJWT(localStorage.getItem('token')).user_username;
            if (temporary.toString().indexOf('manage03') != -1 || temporary.toString().indexOf('manage032') != -1) {
                this.disasterpeople_disable = false;
            } else {
                this.disasterpeople_disable = true;
            }

            this.loading = true;
            this.disasterStatusOptions = [
                { id: 'getall', name: this.$i18n.t('selectAll') },
                { id: 'onworking', name: this.$i18n.t('onworking') },
                { id: 'finish', name: this.$i18n.t('finish') },
                { id: 'notify', name: this.$i18n.t('notify') }
            ];
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: {
                        group: 'dg-02'
                    }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/disaster`, {
                    body: { topic: 'get-table-people' }
                })
                .then((response) => {
                    (this.loading = false), (this.disasterInfo_table = response.data.data);

                    this.formatData(this.disasterInfo_table);

                    // console.log("this.disasterInfo_table",this.disasterInfo_table)
                });
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                data[index]['index'] = index + 1;
                const element = data[index].event_date_alias.split('/');

                let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);

                data[index].event_date_alias = moment(dateNew).locale('th').add(543, 'year').format('LLL');

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        // selectedOrganize_passValue(variable) {
        //   this.showOrganize = false;
        //   this.selectedOrganize = {
        //     id: variable.organize_id,
        //     name: variable.organize_name,
        //   };
        // },

        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                this.organize_table = [];
                for (let i = 0; i < variable.length; i++) {
                    this.organize_table.push({
                        organize_id: variable[i].organize_id,
                        organize_name: variable[i].organize_name
                    });
                }
            }
        },

        async searchDisasterInfo() {
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            this.loading = true;
            // var start_date, to_date;
            // if (this.startDate != null) {
            //   const start = new Date(this.startDate);
            //   const ye_s = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            //     start
            //   );
            //   const mo_s = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            //     start
            //   );
            //   const da_s = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            //     start
            //   );
            //   start_date = `${ye_s}-${mo_s}-${da_s}`;
            // } else {
            //   start_date = "";
            // }

            // if (this.toDate != null) {
            //   const to = new Date(this.toDate);
            //   const ye_t = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            //     to
            //   );
            //   const mo_t = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            //     to
            //   );
            //   const da_t = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            //     to
            //   );
            //   to_date = `${ye_t}-${mo_t}-${da_t}`;
            // } else {
            //   to_date = "";
            // }

            const reportEvent_startTime = new Date(moment().set({ hour: 0, minute: 0, second: 0 }));
            const reportEvent_endTime = new Date(moment().set({ hour: 23, minute: 59, second: 59 }));

            let New_start_date = null;
            if (this.startDate != null) {
                New_start_date = `${moment(this.startDate).format('YYYY-MM-DD')} ${moment(reportEvent_startTime).format('HH:mm:ss')}`;
            } else {
                New_start_date = null;
            }

            let New_to_Date = null;
            if (this.toDate != null) {
                New_to_Date = `${moment(this.toDate).format('YYYY-MM-DD')} ${moment(reportEvent_endTime).format('HH:mm:ss')}`;
            } else {
                New_to_Date = null;
            }

            // console.log("New_start_date",New_start_date)
            // console.log("New_to_Date",New_to_Date)
            await this.axios
                .post(`${this.$url_service}/disaster`, {
                    body: {
                        topic: 'search-table-people',
                        name: this.event_name,
                        // startdate: start_date,
                        // todate: to_date,
                        startdate: New_start_date == null ? (New_start_date = '') : New_start_date,
                        todate: New_to_Date == null ? (New_to_Date = '') : New_to_Date,
                        disaster: this.disasterTypeSelect,
                        // detail: this.disasterDetailSelect,
                        detail: this.disaster_detail,
                        status: this.disasterStatusSelect,
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        location: this.disaster_location,
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลักที่ค้นหา
                        organize: this.organize_table
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(), //เช็คสิทธิ์
                    }
                })
                .then((response) => {
                    (this.loading = false), (this.disasterInfo_table = response.data.data);

                    this.formatData(this.disasterInfo_table);

                    // console.log(this.disasterInfo_table)

                    this.setSearchText_Footer();
                });
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.event_name !== '' ||
                this.checkDateNull_String(this.startDate) ||
                this.checkDateNull_String(this.toDate) ||
                this.disasterTypeSelect !== null ||
                this.disasterStatusSelect !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null ||
                this.disaster_location !== '' ||
                this.disaster_detail !== ''
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานหลัก' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อเหตุการณ์' && this.event_name !== '') {
                        element.textShow = this.event_name;
                    }
                    if (element.DataName === 'จากวันที่' && this.startDate !== null && this.startDate !== '') {
                        element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.startDate)), 'string');
                    }
                    if (element.DataName === 'ถึงวันที่' && this.toDate !== null && this.toDate !== '') {
                        element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.toDate)), 'string');
                    }
                    if (element.DataName === 'ประเภทสาธารณภัย' && this.disasterTypeSelect !== null) {
                        element.textShow = this.disasterTypeSelect.system_name;
                    }
                    if (element.DataName === 'สถานะเหตุการณ์' && this.disasterStatusSelect !== null) {
                        element.textShow = this.disasterStatusSelect.name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                    if (element.DataName === 'สถานที่เกิดเหตุ' && this.disaster_location !== '') {
                        element.textShow = this.disaster_location;
                    }
                    if (element.DataName === 'ลักษณะที่เกิดเหตุ' && this.disaster_detail !== '') {
                        element.textShow = this.disaster_detail;
                    }
                }
                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        checkDateNull_String(info) {
            if (typeof info === 'object' && info !== null) {
                return true;
            } else {
                if (info !== null && info !== '' && info.length === 10) {
                    return true;
                } else {
                    return false;
                }
            }
        },

        updateStatus(status, id) {
            if (this.disasterpeople_disable == false) {
                this.temp = { status: status, hazard_id: id };
                this.displayApproveModal = true;
            } else {
                // this.$toast.add({
                //   severity: "error",
                //   summary: "เกิดข้อผิดพลาด",
                //   detail: "คุณไม่มีสิทธิ์ในการยืนยันเหตุการณ์",
                //   life: 10000,
                // });

                this.$fire({
                    title: 'คุณไม่มีสิทธิ์ในการแก้ไขข้อมูล',
                    // text: "คุณไม่มีสิทธิ์ในการลบข้อมูล",
                    type: 'warning',
                    timer: 10000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async updateDisaster() {
            await this.axios
                .post(`${this.$url_service}/disaster`, {
                    body: {
                        topic: 'approve-disaster',
                        status: this.temp['status'],
                        hazard_id: this.temp['hazard_id'],
                        userOrg: this.getUserOrganize()
                    }
                })
                .then(() => {
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "บันทึกข้อมูลสำเร็จ",
                    //   detail: "ข้อมูลสาธารณภัย",
                    //   life: 3000,
                    // });
                    this.$fire({
                        title: 'บันทึกข้อมูลสำเร็จ',
                        text: 'ข้อมูลสาธารณภัย',
                        type: 'success',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.displayApproveModal = false;
                });
            this.initialData();
        },

        rowClass(data) {
            if (data.from_flag == -1) {
                return 'reject';
            } else if (data.from_flag == 1) {
                return 'approve';
            }
        },

        async clearSearchField() {
            this.event_name = '';
            this.disaster_detail = '';
            this.startDate = null;
            this.toDate = null;
            this.organize_table = [];
            this.disasterTypeSelect = null;
            this.disasterStatusSelect = null;
            this.selectedProvince = null;
            this.disaster_location = '';
            this.selectedOrganize = {};

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // await this.axios
            //   .post(`${this.$url_service}/disaster`, { body: { topic: "get-table" } })
            //   .then((response) => (this.disasterInfo_table = response.data.data));
            this.initialData();
        },

        confirmDelete() {
            if (this.deleteTable == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            }
        },

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        }
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
